import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettingsBase } from '../../../_models/admin/settings/settings.base';
import { AdminSettingsService } from '../../../_services/admin/admin-settings.service';
import { MainService } from 'app/_services/main.service';

@Component({
  selector: 'app-supplier-interface-cross',
  templateUrl: './supplier-interface-cross.component.html',
  styleUrl: './supplier-interface-cross.component.scss'
})
export class SupplierInterfaceCrossComponent {
  settings: SettingsBase;


  constructor(
    public adminSettingsService: AdminSettingsService,
    public mainService: MainService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.data
      .subscribe((data: any) => {
        this.settings = data.settings;
      });
  }

  getInterfaceKindFromSupplierInterfaceCross(supplier: string): string {
    if (this.getSupplierInterfaceCross() && this.getSupplierInterfaceCross()[supplier] !== undefined) {
      let interfaceKindKey = this.getSupplierInterfaceCross()[supplier];
      let interfaceKind = this.getInterfaceKinds()[interfaceKindKey];
      return interfaceKind;
    }
    return 'None';
  }

  getInterfaceKinds(): { [key: number]: string } {
    return this.adminSettingsService.getAdminSetting(this.settings, 'InterfaceKinds').Value;
  }

  getFilteredInterfaceKinds(supplier: string): { [key: number]: string } {
    const getSupplierInterfaceCross = this.getSupplierInterfaceCross();
    const interfaceKinds = this.getInterfaceKinds();
    let filteredInterfaceKinds: { [key: number]: string } = {};
    for (const key in interfaceKinds) {
      if (+key === -1 || getSupplierInterfaceCross[supplier] === +key || !Object.values(getSupplierInterfaceCross).includes(+key)) {
        filteredInterfaceKinds[key] = interfaceKinds[key];
      }
    }
    return filteredInterfaceKinds;
  }

  getSupplierInterfaceCross(): { [key: string]: number } {
    return this.adminSettingsService.getAdminSetting(this.settings, 'SupplierInterfaceCross').Value;
  }

  setInterfaceKindForSupplierInterfaceCross(supplier: string, interfaceKind: string) {
    const getSupplierInterfaceCross = this.getSupplierInterfaceCross();
    const interfaceKindKey = Object.keys(this.getInterfaceKinds()).find(key => this.getInterfaceKinds()[key] === interfaceKind);
    getSupplierInterfaceCross[supplier] = +interfaceKindKey;
  }

  getBrightArticleMappingKey(supplier: string): string {
    const key = supplier + '_LeverancierNr';
    if (this.getBrightArticleMappingsSuppliers() && this.getBrightArticleMappingsSuppliers()[key] !== undefined) {
      let articleMappingKey = this.getBrightArticleMappingsSuppliers()[key];
      return articleMappingKey;
    }
    return '';
  }

  getBrightArticleMappingsSuppliers(): { [key: string]: string } {
    return this.adminSettingsService.getAdminSetting(this.settings, 'BrightArticleMappingsSuppliers').Value;
  }

  setBrightArticleMappingKey(supplier: string, articleMappingKey: string) {
    const brightArticleMappingsSuppliers = this.getBrightArticleMappingsSuppliers();
    brightArticleMappingsSuppliers[supplier + '_LeverancierNr'] = articleMappingKey;
  }

  getBrightSupplier(supplier: string): number {
    const key = supplier + '_LeverancierNr';
    if (this.BrightSuppliersCross() && this.BrightSuppliersCross()[key] !== undefined) {
      let brightSupplier = this.BrightSuppliersCross()[key];
      return brightSupplier;
    }
    return 0;
  }

  BrightSuppliersCross(): { [key: string]: number } {
    return this.adminSettingsService.getAdminSetting(this.settings, 'BrightSuppliersCross').Value;
  }

  setBrightSupplier(supplier: string, brightSupplier: number) {
    const brightSuppliersCross = this.BrightSuppliersCross();
    brightSuppliersCross[supplier + '_LeverancierNr'] = +brightSupplier;
  }

  isSupplierEmpty(supplier: string): boolean {
    const getSupplierInterfaceCross = this.getSupplierInterfaceCross();
    if (getSupplierInterfaceCross[supplier] != -1) return false;
    const brightArticleMappingsSuppliers = this.getBrightArticleMappingsSuppliers();
    if (brightArticleMappingsSuppliers[supplier + '_LeverancierNr']) return false;
    const brightSuppliersCross = this.BrightSuppliersCross();
    if (brightSuppliersCross[supplier + '_LeverancierNr'] && +brightSuppliersCross[supplier + '_LeverancierNr'] > 0) return false;
    return true;
  }

  addSupplier() {
    this.mainService.inputBoxExtended('Toevoegen Leverancier', 'Leveranciersnaam', '', false, 'modal-md')
      .subscribe(naam => {
        naam = naam.replace(/\s+|[^\w]/g, '_');
        if (naam) {
          const suppliers = this.adminSettingsService.getAdminSetting(this.settings, 'Suppliers').Value;
          suppliers.push(naam);
          suppliers.sort();
          const supplierInterfaceCross = this.getSupplierInterfaceCross();
          supplierInterfaceCross[naam] = -1;
        }
      });
  }

  deleteSupplier(supplier: string) {
    const suppliers = this.adminSettingsService.getAdminSetting(this.settings, 'Suppliers').Value;
    suppliers.splice(suppliers.indexOf(supplier), 1);
    const supplierInterfaceCross = this.getSupplierInterfaceCross();
    delete supplierInterfaceCross[supplier];
    const brightArticleMappingsSuppliers = this.getBrightArticleMappingsSuppliers();
    delete brightArticleMappingsSuppliers[supplier + '_LeverancierNr'];
    const brightSuppliersCross = this.BrightSuppliersCross();
    delete brightSuppliersCross[supplier + '_LeverancierNr'];
  }

}
